/** @jsxImportSource theme-ui */
export const MISSING_VALUE = '—';

export type ValueCellProps<Value> = { cell: { value?: Value | null } };

export const YesNoCell = ({ cell }: ValueCellProps<boolean>) => <>{cell.value ? 'Yes' : 'No'}</>;

export const ValueOrMissingCell = ({ cell }: ValueCellProps<string | number>) => (
    <>{cell.value ?? MISSING_VALUE}</>
);
